import { VipLevelFormValues } from './types';

export const VIP_LEVEL_FORM_INITIAL_VALUES: VipLevelFormValues = {
  level: 0,
  title: '',
  iconId: '',
  levelPoints: 0,
};
